module.exports = __webpack_public_path__ + "img/router_mode.6d29e8ab.svg";